import React from "react";
import Select from "react-select";
import { EMPTY_STRING, sharedConstants } from "../../../constants";

const MultiSelectDropdown = ({
  options,
  selectedValues,
  onSelectionChange,
  label = null,
  placeholder = "Select...",
  labelKey = "label",
  valueKey = sharedConstants.OBJECT, // "object" OR any key like "id", "eventId", "recapId" which you want in return onSelectionChange
  isClearable = false,
}) => {
  // Handle change event
  const handleSelectionChange = (selectedOptions) => {
    if (valueKey === sharedConstants.OBJECT) {
      onSelectionChange(selectedOptions || []);
    } else {
      const values = selectedOptions
        ? selectedOptions.map((opt) => opt[valueKey]) // return specific field
        : [];
      onSelectionChange(values);
    }
  };

  // Map stored values back to objects so react-select can show them
  const showSelectedValues = () => {
    if (valueKey === sharedConstants.OBJECT) {
      return selectedValues;
    }
    const data = options.filter((opt) =>
      selectedValues?.includes(opt[valueKey])
    );

    return data;
  };

  return (
    <div className="multi-select-container">
      {label && <label className="label-content-600">{label}</label>}
      <Select
        isMulti
        options={options}
        value={showSelectedValues()}
        onChange={handleSelectionChange}
        placeholder={placeholder}
        getOptionValue={(opt) => opt[valueKey] || opt.value}
        getOptionLabel={(option) => option[labelKey] ?? EMPTY_STRING}
        classNamePrefix="multi-select"
        className="multi-select"
        isClearable={isClearable}
      />
    </div>
  );
};

export default MultiSelectDropdown;
